<template>
    <div class="contract-list">
        <h3>合同管理</h3>

        <el-table :data="list" size="mini" v-loading="loading">
            <el-table-column prop="contractId" label="合同编号"></el-table-column>
            <el-table-column prop="jobTitle" label="职位名称">
                <template slot-scope="scope">
                    <a :href="`${frontUrl}/job/detail/${scope.row.jobId}`" target="_blank">{{scope.row.jobTitle}}</a>
                </template>
            </el-table-column>
            <el-table-column prop="partyAName" label="甲方名称"></el-table-column>
            <el-table-column prop="partyBName" label="乙方名称"></el-table-column>
            <el-table-column prop="type" label="合同类型">
                <template slot-scope="scope">{{map.order.contractType[scope.row.type]}}</template>
            </el-table-column>
            <el-table-column prop="" label="合同金额">
                <template slot-scope="scope">
                    <template v-if="scope.row.type === 1">{{scope.row.hourlyHour}}元/小时</template>
                    <template v-else>{{scope.row.totalAmount}}元</template>
                </template>
            </el-table-column>
            <el-table-column prop="status" label="合同状态">
                <template slot-scope="scope">{{map.order.contractStatus[scope.row.status]}}</template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间"></el-table-column>
            <el-table-column prop="signingTime" label="签订时间"></el-table-column>
            <el-table-column prop="" label="操作" width="200">
                <template slot-scope="scope">
                    <el-button-group>
                    <el-button size="mini" type="success" @click="getToken(scope.row.contractId)">查看合同</el-button>
                    <el-button size="mini" type="success" @click="getDetail(scope.row.contractId)">修改订单</el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <br/>

        <div style="float: right">
            <el-pagination background layout="prev, pager, next" @current-change="i=>pageNum=i" :page-size="limit" :total="total">
            </el-pagination>
        </div>

        <el-dialog title="查看合同" :visible.sync="dialog.token" :fullscreen="true">
            <!-- <p>例1：http://ourwork-test.nework666.net?encrypt_code=123</p>
            <p>例2：http://ourwork-test.nework666.net?a=1&encrypt_code=123</p>
            <br>
            <p class="code">{{token}}</p>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialog.token = false">取 消</el-button>
            </div> -->
            <iframe :src="iframeUrl" width="100%" :height="iframeHeight" frameborder="0"></iframe>
        </el-dialog>

        <el-dialog title="修改订单信息" :visible.sync="dialog.detail">
            <el-form label-width="120px" :model="orderInfo" :rules="rules" ref="orderInfo">
                <template v-if="orderInfo.type === 1">
                    <el-form-item label="时薪金额" prop="hourlyHour">
                        <el-input type="text" v-model="orderInfo.hourlyHour" />
                    </el-form-item>
                    <el-form-item label="每日工作时长" prop="workTimePerDay">
                        <el-input type="text" v-model="orderInfo.workTimePerDay" @input="change($event)" /></el-input>
                    </el-form-item>
                    <el-form-item label="月薪金额" prop="monthlyRate">
                        <el-input type="text" v-model="orderInfo.monthlyRate" />
                    </el-form-item>
                </template>
                <template v-else>
                    <el-form-item label="项目金额" prop="totalAmount">
                        <el-input type="text" v-model="orderInfo.totalAmount" />
                    </el-form-item>
                    <el-form-item label="项目截止日" prop="projectDeadline">
                        <el-date-picker  v-model="orderInfo.projectDeadline" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="项目截止日" style="width: 100%;"></el-date-picker>
                    </el-form-item>
                </template>
                <el-form-item label="工作内容">
                    <el-input type="textarea" v-model="orderInfo.workStandard" :rows="5" />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submit">确定</el-button>
                    <el-button @click="toggleDialog('detail')">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

    </div>
</template>
<script>
import api from "../api";
import map from "../../datamap";

const { order } = api;

export default {
  name: "contract-list",
  data() {
    return {
      map,
      loading: true,
      list: [],
      total: 0,
      limit: 20,
      pageNum: 1,
      dialog: {
        token: false,
        detail: false,
      },
      token: "",
      iframeUrl: "",
      orderInfo: {
        workTimePerDay: "",
      },
      rules: {
        hourlyHour: [
          {
            required: true,
            message: "请输入时薪",
            trigger: "blur",
          },
        ],
        workTimePerDay: [
          {
            required: true,
            message: "请输入每日工作时长",
            trigger: "blur",
          },
        ],
        monthlyRate: [
          {
            required: true,
            message: "请输入月薪",
            trigger: "blur",
          },
        ],
        totalAmount: [
          {
            required: true,
            message: "请输入项目金额",
            trigger: "blur",
          },
        ],
        projectDeadline: [
          {
            required: true,
            message: "请输入项目截止时间",
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {},
  computed: {
    jobId() {
      return this.$route.query.jid || "";
    },
    iframeHeight() {
      return window.innerHeight * 0.9;
    },
  },
  watch: {
    pageNum() {
      this.fetch(2);
    },
  },
  methods: {
    change(e) {
      this.$forceUpdate();
    },
    async fetch(num) {
      if (num == 1) {
        this.pageNum = 1;
      }
      let pageNum = this.pageNum;
      let limit = this.limit;
      this.loading = true;

      let obj = {
        pageNum: pageNum,
        limit: limit,
        jobId: this.jobId,
      };

      let res = await order.contracts(obj);

      this.list = res.data.data;
      this.loading = false;
      this.total = res.data.pageinfo.totalCount;
    },
    toggleDialog(name) {
      this.dialog[name] = !this.dialog[name];
    },
    async getToken(contractId) {
      let obj = {
        contractId: contractId,
      };
      let {
        data: { code, data },
      } = await order.token(obj);
      if (code == 200) {
        // this.token = data;
        // this.toggleDialog('token');

        this.iframeUrl = `${this.frontUrl}/order/detail/${contractId}?tab=contract&encrypt_code=${data}`;
        this.toggleDialog("token");
      }
    },
    async getDetail(contractId) {
      let obj = {
        contractId: contractId,
      };
      let {
        data: { code, data },
      } = await order.detail(obj);
      if (code == 200) {
        this.orderInfo = data;
        this.orderInfo.workTimePerDay = data.weeklyLimit / 5;
        this.toggleDialog("detail");
      }
    },
    submit() {
      this.$refs.orderInfo.validate((valid) => {
        if (valid) this.updateOrder();
      });
    },
    async updateOrder() {
      let {
        contractId,
        type,
        hourlyHour,
        weeklyLimit,
        workTimePerDay,
        monthlyRate,
        totalAmount,
        projectDeadline,
        workStandard,
      } = this.orderInfo;
      let obj = {
        contractId,
        type,
        hourlyHour,
        weeklyLimit: workTimePerDay * 5,
        monthlyRate,
        totalAmount,
        projectDeadline,
        workStandard,
      };
      let {
        data: { code, data },
      } = await order.update(obj);
      if (code == 200) {
        this.$message.success("修改成功！");
        this.toggleDialog("detail");
        this.fetch();
      }
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/order/contracts.vue